/**
 * ResponsableLayout — wrapper des pages /responsable/*
 * Affiche l'établissement du responsable dans le header (Sticker menthe).
 */
import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';
import { AuthLayoutShell } from './AuthLayoutShell';
import { Sticker } from '@/components/passage/Sticker';
import { SidebarLink } from '@/components/passage/SidebarLink';

// V7 (mai 2026) — type de la réponse enrichie /responsable/me.
type ResponsableMe = {
  formationIds: string[];
  formations: Array<{ id: string; code: string; label: string; level: string }>;
  me: {
    nom: string;
    prenom: string;
    fonction: string | null;
    establishment: {
      id: string;
      slug: string;
      name: string;
      type: string;
      city: string | null;
    } | null;
  } | null;
};

export function ResponsableLayout() {
  const { data: meData } = useQuery({
    queryKey: ['responsable', 'me'],
    queryFn: () => apiFetch<ResponsableMe>('/responsable/me'),
    // Le super-admin peut emprunter ce layout pour test — pas grave si null.
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
  const establishment = meData?.me?.establishment;

  return (
    <AuthLayoutShell
      homePath="/responsable"
      roleLabel="Responsable"
      roleColor="menthe"
      navAriaLabel="Navigation responsable"
      footerText={`© ${new Date().getFullYear()} Stelvyo — espace responsable de formation`}
      extraHeader={
        establishment && (
          <span className="hidden lg:inline-block">
            <Sticker color="cream" rotate={2} shadow="xs">
              {establishment.name}
              {establishment.city ? ` · ${establishment.city}` : ''}
            </Sticker>
          </span>
        )
      }
      sidebar={
        <>
          <SidebarLink to="/responsable" end>Tableau de bord</SidebarLink>
          <SidebarLink to="/responsable/entreprises">Inscriptions entreprises</SidebarLink>
          <SidebarLink to="/responsable/etudiants">Étudiants</SidebarLink>
          <SidebarLink to="/responsable/annonces">Annonces</SidebarLink>
          <SidebarLink to="/responsable/annonces-externes">Annonces externes</SidebarLink>
          <SidebarLink to="/responsable/candidatures">Candidatures</SidebarLink>
          {/* V13 — CRM recrutement */}
          <SidebarLink to="/responsable/suivi-recrutements">Suivi recrutements</SidebarLink>
          <SidebarLink to="/responsable/invitations">Invitations</SidebarLink>
          <SidebarLink to="/responsable/exports">Exports</SidebarLink>
          <SidebarLink to="/responsable/aide">Aide</SidebarLink>
        </>
      }
    />
  );
}
